'use client';

import { __styles, mergeClasses } from '@griffel/react';
export const carouselViewportClassNames = {
  root: 'fui-CarouselViewport'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    B2u0y6b: "f6dzj5z",
    a9b677: "f14z66ap"
  }
}, {
  d: [".f6dzj5z{max-width:100%;}", ".f14z66ap{width:auto;}"]
});
/**
 * Apply styling to the CarouselViewport slots based on the state
 */
export const useCarouselViewportStyles_unstable = state => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(carouselViewportClassNames.root, styles.root, state.root.className);
  return state;
};